import { createContext, useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthToken } from "../../../utils/authToken";
import { isFranchisePortalSession } from "../../../utils/franchiseSession";
import config from "../../../../config.json";

const API = import.meta.env.VITE_REACT_APP_BACKEND_URL || config.dev;

const PlanAccessContext = createContext({ planExpired: false });

export function PlanAccessProvider({ children }) {
  const franchisePortal = isFranchisePortalSession();
  const location = useLocation();
  const [planExpired, setPlanExpired] = useState(false);

  useEffect(() => {
    if (franchisePortal) return undefined;
    let ignore = false;
    (async () => {
      try {
        const response = await fetch(`${API}/billing/plan/status`, {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        });
        if (!response.ok) return;
        const data = await response.json();
        const daysLeft = Number(data.daysRemaining);
        const expired =
          Boolean(data.planExpired) ||
          (Number.isFinite(daysLeft) && daysLeft <= 0);
        if (!ignore) setPlanExpired(expired);
      } catch {
        /* keep the backoffice usable if billing status cannot be loaded */
      }
    })();
    return () => {
      ignore = true;
    };
  }, [franchisePortal, location.pathname]);

  return (
    <PlanAccessContext.Provider value={{ planExpired: franchisePortal ? false : planExpired }}>
      {children}
    </PlanAccessContext.Provider>
  );
}

export function usePlanAccess() {
  return useContext(PlanAccessContext);
}

export function PlanLockedScreen() {
  const { t } = useTranslation();

  return (
    <section className="plan-locked">
      <p className="plan-locked__eyebrow">{t("planExpiredTitle", { defaultValue: "Plan expired" })}</p>
      <h1>{t("planExpiredTitle", { defaultValue: "Plan expired" })}</h1>
      <p>
        {t("planExpiredLocked", {
          defaultValue:
            "Menu & kitchen, Guests, and Events are locked. Buy a plan to use them.",
        })}
      </p>
      <Link to="/plans" className="plan-locked__buy">
        {t("buyPlan", { defaultValue: "Buy a plan" })}
      </Link>
    </section>
  );
}
